import React from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

export default function Career() {
  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt-3">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div className="col-sm-9" style={{ marginTop: "5px" }}>
                  <div className="row mt-0">
                    <div className="col-sm-12">
                      <div className="inner_content contactpage">
                        <h2>PURCHASE PROCEDURE</h2>
                        <div className="clearfix"></div>
                        <p>
                          In super session of all previous orders regarding the
                          procedure for purchases, the following procedure may
                          be followed hereafter for procurement of raw
                          materials, packing materials, machines & equipment,
                          spare parts, furniture, stationery, consumable stores,
                          and all items which may be required by IDPL Corporate
                          Office, Plants, and Sales Offices.
                        </p>
                        <p>
                          <strong>1. The Committees:</strong> Suitable
                          committees may be formed for the purpose. In the
                          Plants, the composition of Committee may be as under:-
                          <br />
                          <strong>
                            Plant Procurement & Requirement Committee (PPC): At
                            each Plant
                          </strong>
                        </p>
                        <table>
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              <th>Name</th>
                              <th>Designation</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                              <td>
                                General Manager /G.M.(I/C)/ Plant (I/C) or his
                                nominee.
                              </td>
                              <td>Chairman</td>
                            </tr>
                            <tr>
                              <td>2</td>
                              <td>Senior most Officer of Production Deptt.</td>
                              <td>Member</td>
                            </tr>
                            <tr>
                              <td>3</td>
                              <td>Senior most Officer of Finance Deptt.</td>
                              <td>Member</td>
                            </tr>
                            <tr>
                              <td>4</td>
                              <td>Indenting Officer.</td>
                              <td>By invitation</td>
                            </tr>
                            <tr>
                              <td>5</td>
                              <td>
                                Senior most Officer of Purchase & Stores Deptt.
                              </td>
                              <td>Member Secretary</td>
                            </tr>
                          </tbody>
                        </table>
                        It can be reconstituted by concerned GM in the absence
                        of any officer mentioned above.
                        <p>
                          <strong>2. Purchase Powers:</strong> The Purchase
                          Powers are detailed in Annexure-I.
                        </p>
                        <p>
                          Statement Indicating Delegation of Powers Regarding
                          Purchase on Landed Cost Basis.
                        </p>
                        <table>
                          <thead>
                            <tr>
                              <th>Sr.No</th>
                              <th>Name of Purchase</th>
                              <th>
                                PPC at Plants and Committees at Corporate Office{" "}
                              </th>
                              <th>
                                Head of P&S at Plants & Division I/C at Sales
                                Offices
                              </th>
                              <th>Regional Sales Offices (RSOs)</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                              <td>
                                Purchase against DGS&D RateContract or through
                                Central/State Govt. Undertakings or through
                                Registered vendors.
                              </td>
                              <td>Full powers</td>
                              <td>Rs. 25 Lakhs</td>
                              <td>Rs. 1 Lakh</td>
                            </tr>
                            <tr>
                              <td>2</td>
                              <td>
                                By Open/Limited Tender where more than 1(one)
                                tender is received, provided the lowest
                                technically acceptable tender is accepted
                              </td>
                              <td>
                                1. Full Powers
                                <br />
                                2. Full Powers
                              </td>
                              <td>
                                1. Rs. 12 Lakhs
                                <br />
                                2. Rs. 5 Lakhs
                              </td>
                              <td>
                                1. Rs. 50000/-
                                <br />
                                2. Rs. 25000/-
                              </td>
                            </tr>
                            <tr>
                              <td>3</td>
                              <td>
                                By Open/Limited Tender where one tender only is
                                received or by single tender enquiry where there
                                is only one known Manufacturer/Proprietary
                                articles (including Negotiation)
                              </td>
                              <td>Full Powers</td>
                              <td>Rs. 2 Lakhs</td>
                              <td>Rs. 10000/-</td>
                            </tr>
                            <tr>
                              <td>4</td>
                              <td>By Repeat Orders</td>
                              <td>Full Powers</td>
                              <td>Rs. 5 Lakhs</td>
                              <td>Rs. 25000/-</td>
                            </tr>
                            <tr>
                              <td>5</td>
                              <td>
                                Purchase against emergency & local purchase)
                              </td>
                              <td>Full Powers</td>
                              <td>Rs. 2 Lakhs</td>
                              <td>Rs. 10000/-</td>
                            </tr>
                          </tbody>
                        </table>
                        <br />
                        <p>
                          Recommendations of the PPC be finally approved by the
                          General Manager at plants. Recommendations of
                          committees at Corporate Office to be approved by the
                          CMD or the Officers to whom the powers are delegated.
                        </p>
                        <p>
                          <b>3. Tenders & Enquiries</b>
                          <br />
                          A. <b>Raw Materials (Bulk Drugs) & Excipients:</b> For
                          all materials except direct import. Direct Import to
                          be dealt by Corporate Office.
                          <br />
                          (i).{" "}
                          <b>
                            <u>
                              Registration of Vendors for Bulk drugs and
                              Excipients:
                            </u>
                          </b>{" "}
                          In order to have wide publicity, advertisement is to
                          be released in leading newspapers of the country,
                          inviting applicants to enlist the name of vendors. In
                          the advertisement, the details of bulk drugs &
                          excipients are to be mentioned and no quantities are
                          to be specified. The list of registered vendors should
                          be placed on the website. This exercise may be done
                          for all the plants at Corporate Office or individually
                          by all plants.
                          <br />
                          (ii).{" "}
                          <b>
                            <u>Enquiries</u>
                          </b>
                          :
                          <br />
                          (a). The enquiries are to be forwarded by individual
                          plants on monthly/quarterly requirement basis to all
                          enlisted vendors by FAX/E-mail/Courier giving seven
                          days time to receive the offer. Sealed quotations may
                          be invited, as a general rule, also mentioning the
                          time of opening of sealed quotations so that all the
                          interested parties could be present, if they so
                          desire. However, when the requirement is urgent,
                          Tenders may be invited through e-mail/fax also from
                          registered vendors giving time of one day or a few
                          hours to receive the offer.
                          <br />
                          (b). In order to ensure procurement of quality
                          materials and to avoid any rejection, etc, after
                          supply, it is necessary that for new manufacturers
                          minimum three years manufacturing experience with
                          stability data, etc be made a requirement for
                          approving the tender.
                          <br />
                          (iii).{" "}
                          <b>
                            <u>Opening of Tenders</u>
                          </b>
                          <br />
                          (a). Promptly after opening of tenders, a detailed
                          comparative statement may be prepared. The whole
                          process be completed and finalized in two days under
                          normal circumstances and within two hours in
                          urgent/emergent situations. If necessary, G.M. should
                          convene a joint meeting of the concerned officers, to
                          avoid any delay.
                          <br />
                          (b). In case, the lowest tender is not acceptable,
                          full reasons thereof should be recorded on the file.
                          Any change in the specification or in the terms &
                          conditions of tender enquiry, after the tenders are
                          received, should normally not be done. However, if the
                          same is unavoidable keeping in view the interest of
                          the Company, the same be made after recording reasons
                          on the file and approval of competent authority as per
                          delegation of powers.
                          <br />
                          (iv).{" "}
                          <b>
                            <u>Placing of Order</u>
                          </b>
                          <br />
                          (a). Immediately on finalization of the party based on
                          the comparative statement, the Purchase Order should
                          be issued.
                          <br />
                          (b). Since procurement is done from the registered
                          vendors as per the procedure detailed above, there
                          would not be any upper limit in terms of value of
                          items to be purchased.
                          <br />
                          (c). To cross-check the rates mentioned in the
                          journals like Chemical Weekly, Pharma Biz, Pharma
                          Pulse, etc., may be referred and a comparison may be
                          made with the offers received to check the
                          reasonability of rates. Thus the “Tender Enquiry” to
                          “Placing of Order” should be completed in ten days
                          under normal circumstances and within one day in
                          emergent circumstances.
                          <br />
                          (v).{" "}
                          <b>
                            <u>Single Tender Enquiry</u>
                          </b>
                          <br />
                          (a). Single tender enquiry may be issued in case of
                          proprietary items or where there is only a single
                          manufacturer of the items. Head of Purchase and Stores
                          (P&S) may record in consultation with the indenter
                          that to the best of their knowledge, there is a single
                          manufacturer of the item.
                          <br />
                          (b). In the case of a single tender for proprietary
                          items, negotiations may be carried out. In all other
                          cases, the negotiations may be carried out with L-1
                          only.
                          <br />
                          (vi).{" "}
                          <b>
                            <u>Local Purchase</u>
                          </b>
                          : Small value items, as per the delegation of powers
                          (Annexure-I) may be purchased locally, by deputing
                          Purchase Committee consisting of representatives from
                          Purchase, Finance & Indenters by collecting sealed
                          offers from local vendors. However, in emergent cases,
                          individual items having value below Rs.10,000/- may be
                          procured without quotation with approval of General
                          Manager/Competent Authority.
                          <br />
                          B. <b>Packing Material by Plants</b>
                          <br />
                          (a). Plants may conclude Rate Contract (R/C) for the
                          purchase of packing materials through open
                          Advertisement. After approving their quality, the Rate
                          Contract may be concluded for one year. Subsequently,
                          as per market information, if the rates are reduced
                          than the approved rates, even after concluding the
                          Rate Contract, negotiations may be carried out, and
                          advantage of reduced rates can be availed, without
                          compromising with quality.
                          <br />
                          (b). For bulk purchases, preference should be given to
                          manufacturers if they give their offer. In case the
                          manufacturers are not giving offers, then traders are
                          considered if their offers are in accordance with our
                          terms and conditions.
                          <br />
                          (c). For common and low-value packing materials such
                          as corrugated boxes, glass bottles, etc., preference
                          may be given to local suppliers as outside suppliers
                          may not be interested due to low costs of material and
                          involvement of higher freight cost.
                          <br />
                          (d). Guidelines regarding opening of tender, placing
                          of order, single tender enquiry and local purchase
                          etc. remain the same as under the heading “Raw
                          Material & Excipients”.
                          <br />
                          C.{" "}
                          <b>
                            <u>
                              Machines/Equipments/Engineering Spares &
                              Maintenance and Miscellaneous items
                            </u>
                          </b>
                          <br />
                          (i).{" "}
                          <u>
                            Limited Tender for items with value up to Rs. 15
                            Lakhs
                          </u>
                          : For the purchase of a single item not exceeding
                          Rs.15 lakhs, for which a good number of suppliers are
                          known, LTE may be resorted to, if considered
                          advantageous. LTE should be issued to a maximum number
                          of known manufacturers/suppliers for which reference
                          can be made to the Internet, Buyers Guide & Journals,
                          etc. LTE should be issued by Fax/e-mail/Courier giving
                          07 to 15 days to receive the offer. It should also be
                          put on the website if possible.
                          <br />
                          (ii). <u>Advertised Tender</u>: Purchase of a single
                          item exceeding Rs.15 lakhs should be made by open
                          advertisement giving 07-15 days time for receiving the
                          offer. If this cannot be done, reasons may be recorded
                          in writing & approval for the same may be obtained
                          from CMD.
                          <br />
                          (iii). Guidelines regarding opening of tender, placing
                          of order, single tender enquiry and local purchase
                          etc. remain the same as under the heading “Raw
                          Material & Excipients”.
                        </p>
                        <p>
                          <b>4. Extension of Delivery Date:</b> In case the
                          contractor is not at fault, the extension of the
                          delivery date may be decided by G.M. However, if the
                          contractor is at fault, the extension may be allowed
                          and the levy
                        </p>
                        {/* Continuing the rest of the content */}
                        <div className="clearfix"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
